import { ISmartStorageProvider, LocalStorageProvider } from './LocalStorageProvider';

export class DevSettingsStorage {
    settings: ISmartStorageProvider<{[key: string]: boolean}>;
    static inject = () => [LocalStorageProvider];
    constructor(private storage: LocalStorageProvider) {
        this.settings = this.storage.getJSONProvider('dev-settings', { userNeutral: true, envNeutral: true });
    }
}

export class DevSettings {
    static inject = () => [DevSettingsStorage];

    constructor(private storage: DevSettingsStorage) {
        const settings = this.storage.settings.get();
        if (settings){
            this.useStaging = settings.useStaging || false;
            this.simulateNative = settings.simulateNative || false;
            this.enableHexagonTools = settings.enableHexagonTools || false;
            this.eligibleForTrial = settings.eligibleForTrial || false;
            this.enableWebBypassUpgrade = settings.enableWebBypassUpgrade || false;
            this.useRealPaymentsEvenIfBypassEnabled = settings.useRealPaymentsEvenIfBypassEnabled || false;
            this.showVeryShortExpiration = settings.showVeryShortExpiration || false;
            this.disableToastAutoDismiss = settings.disableToastAutoDismiss || false;
            this.showApptRecordingNotificationBtn = settings.showApptRecordingNotificationBtn || false;
            this.recordingShortPauseAutoSave = settings.recordingShortPauseAutoSave || false;
            this.disableRecordingContextStart = settings.disableRecordingContextStart || false;
            this.enableUploadRecording = settings.enableUploadRecording || false;
            this.simulateRecordingSuccess = settings.simulateRecordingSuccess || false;
            this.ignoreShortRecordingMessages = settings.ignoreShortRecordingMessages || false;
            this.disableRecordingProcessing = settings.disableRecordingProcessing || false;
            this.showTaskNotificationTestBtn = settings.showTaskNotificationTestBtn || false;
        }
    }

    useStaging: boolean = false;
    simulateNative: boolean = false;
    enableHexagonTools: boolean = false;
    eligibleForTrial: boolean = false;
    enableWebBypassUpgrade: boolean = false;
    useRealPaymentsEvenIfBypassEnabled: boolean = false;
    showVeryShortExpiration: boolean = false;
    disableToastAutoDismiss: boolean = false;
    showApptRecordingNotificationBtn: boolean = false;
    recordingShortPauseAutoSave: boolean = false;
    disableRecordingContextStart: boolean = false;
    enableUploadRecording: boolean = false;
    simulateRecordingSuccess: boolean = false;
    ignoreShortRecordingMessages: boolean = false;
    disableRecordingProcessing: boolean = false;
    showTaskNotificationTestBtn: boolean = false;
}

export class DevSettingsWriter {
    static inject = () => [
        DevSettings,
        DevSettingsStorage
    ];
    constructor(
        private reader: DevSettings,
        private storage: DevSettingsStorage
    ){ }

    setSetting = async (key: string, value: any) => {
        (this.reader as any)[key] = value;
        this.persistLocalStorage();
    };

    private persistLocalStorage = () => {
        this.storage.settings.set({
            useStaging: this.reader.useStaging,
            simulateNative: this.reader.simulateNative,
            enableHexagonTools: this.reader.enableHexagonTools,
            eligibleForTrial: this.reader.eligibleForTrial,
            enableWebBypassUpgrade: this.reader.enableWebBypassUpgrade,
            useRealPaymentsEvenIfBypassEnabled: this.reader.useRealPaymentsEvenIfBypassEnabled,
            showVeryShortExpiration: this.reader.showVeryShortExpiration,
            showApptRecordingNotificationBtn: this.reader.showApptRecordingNotificationBtn,
            recordingShortPauseAutoSave: this.reader.recordingShortPauseAutoSave,
            disableRecordingContextStart: this.reader.disableRecordingContextStart,
            enableUploadRecording: this.reader.enableUploadRecording,
            simulateRecordingSuccess: this.reader.simulateRecordingSuccess,
            ignoreShortRecordingMessages: this.reader.ignoreShortRecordingMessages,
            disableRecordingProcessing: this.reader.disableRecordingProcessing,
            showTaskNotificationTestBtn: this.reader.showTaskNotificationTestBtn
        });
    };

}
